import styled from 'styled-components';
import { TextComponentProps } from '.';

export const Span = styled.span<TextComponentProps>`
  font-size: ${props => props.fontSize ? props.fontSize : '16px'};
  font-weight: ${props => props.fontWeight ? props.fontWeight : 'regular'};
  color: ${props => props.color ? props.color : '#7A7A7A'};
  margin-bottom: 4px;
`;
